import { MutationList } from './mutation-list';
import {MutationTree} from "vuex";
import {configurationOptions, introductionContent, navNames} from "@/store/types";

export type Mutations<S = configurationOptions> = {
    [MutationList.SET_INITIAL_NAVIGATION_VALUES](state: S, payload: navNames[]): void;
    [MutationList.SET_INITIAL_INTRODUCTION_CONTENT](state: S, payload: introductionContent): void;
}

export const mutations: MutationTree<configurationOptions> & Mutations = {
    [MutationList.SET_INITIAL_NAVIGATION_VALUES](state, payload){
        state.navigation = payload;
    },
    [MutationList.SET_INITIAL_INTRODUCTION_CONTENT](state, payload) {
        state.introduction.heading = payload.heading;
        state.introduction.button = payload.button;
        state.introduction.text = payload.text;
    }
}